/* ============================================
   ÅURA STUDIO THERMAL — Theme JS
   ============================================ */

'use strict';

// ---- Accordion ----
document.querySelectorAll('.aura-accordion__trigger').forEach(trigger => {
  trigger.addEventListener('click', () => {
    const item = trigger.closest('.aura-accordion__item');
    const isOpen = item.classList.contains('is-open');

    // Close all in same group
    const group = item.closest('.aura-accordion__list') || item.parentElement;
    group.querySelectorAll('.aura-accordion__item').forEach(i => {
      i.classList.remove('is-open');
      i.querySelector('.aura-accordion__trigger').setAttribute('aria-expanded', 'false');
    });

    // Open clicked if was closed
    if (!isOpen) {
      item.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
    }
  });
});

// ---- Intersection Observer — fade-up on scroll ----
const observeEls = document.querySelectorAll(
  '.aura-recovery__inner, .aura-reflect__content, .aura-membership__headline, .aura-founder-card, .aura-thermal-hero__content'
);

if ('IntersectionObserver' in window) {
  const io = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('animate-fade-up');
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });

  observeEls.forEach(el => {
    el.style.opacity = '0';
    io.observe(el);
  });
}

// ---- Newsletter form ----
const newsletterForms = document.querySelectorAll('.site-footer__newsletter');
newsletterForms.forEach(form => {
  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    const btn = form.querySelector('button');
    const input = form.querySelector('input[type="email"]');
    const original = btn.textContent;

    btn.textContent = '...';
    btn.disabled = true;

    // Shopify customer newsletter signup
    try {
      const fd = new FormData(form);
      const res = await fetch(form.action, {
        method: 'POST',
        body: fd,
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      });

      if (res.ok || res.status === 422) {
        btn.textContent = '✓';
        input.value = '';
        setTimeout(() => {
          btn.textContent = original;
          btn.disabled = false;
        }, 3000);
      } else {
        throw new Error();
      }
    } catch {
      btn.textContent = 'Erreur';
      setTimeout(() => {
        btn.textContent = original;
        btn.disabled = false;
      }, 2000);
    }
  });
});

// ---- Parallax subtle on hero ----
const heroImg = document.querySelector('.aura-hero__bg img, .aura-hero__bg video');
if (heroImg) {
  window.addEventListener('scroll', () => {
    const scrolled = window.scrollY;
    heroImg.style.transform = `translateY(${scrolled * 0.25}px)`;
  }, { passive: true });
}
